<template>
  <div>
    <PageLoader v-bind:storage="appLoading" v-bind:contain="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog v-model="cancelDialog" width="400">
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 18px;
              "
            >
              Do you want to cancel this product ?
            </span>
          </v-flex>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 14px;
              "
            >
              {{ product.name }}
            </span>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#ff1313"
              @click="cancelProduct"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                Yes
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#1BD93B"
              @click="cancelDialog = false"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                No
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start v-if="product.productId">
          <v-flex xs12 sm2 pr-1 py-1 v-if="product.productId.photos.length > 0">
            <v-img
              :src="mediaURL + product.productId.photos[0]"
              height="100px"
              contain
            >
              <template v-slot:placeholder> <ImageLoader /> </template>
            </v-img>
          </v-flex>
          <v-flex xs12 sm10>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <router-link :to="'/Seller/Product/' + product.productId._id">
                  <span
                    style="
                      font-family: poppinslight;
                      font-size: 15px;
                      color: #000000;
                    "
                  >
                    {{ product.name }}
                  </span>
                </router-link>
              </v-flex>
              <v-flex xs12 text-left pt-2>
                <v-layout wrap justify-space-between>
                  <v-flex xs2>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Total Stock
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 17px;
                            color: #000000;
                          "
                        >
                          {{ product.productId.stockQuantity }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Price
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 17px;
                            color: #000000;
                          "
                        >
                          {{ product.price }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Offer
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 17px;
                            color: #000000;
                          "
                        >
                          {{ product.discount }} %
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 v-if="product.colorHex">
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Color
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left v-if="product.colorHex">
                        <v-avatar :color="product.colorHex" size="23" />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 v-if="CATTYPE == 'Restaurant'">
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Type
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left v-if="product.productId.type">
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 16px;
                            color: #000000;
                          "
                        >
                          {{ product.productId.type }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Quantity
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left v-if="product.quantity">
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 17px;
                            color: #000000;
                          "
                          >{{ product.quantity }}</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs12 align-self-center text-left>
            <v-layout wrap class="cblack">
              <v-flex xs12 lg6 py-2>
                <span class="opensansbold">Change Order Status</span>
              </v-flex>
              <v-flex xs12 lg6 py-2>
                <v-select
                  outlined
                  dense
                  color="#FF1313"
                  placeholder="Order Status"
                  v-model="orderStatus"
                  :items="orderStatuses"
                  item-text="name"
                  item-value="value"
                  item-color="#FF1313"
                  hide-details
                  @change="changeStatus()"
                  item-disabled="disabled"
                >
                  <template v-slot:item="{ item }">
                    <span class="text-left">
                      {{ item.name }}
                    </span>
                  </template>
                </v-select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>

          <v-flex xs12 align-self-center text-left>
            <v-layout wrap class="cblack">
              <v-flex xs12 align-self-center>
                <span class="opensansbold cblack">Shipping Information</span>
              </v-flex>
              <v-flex xs12 align-self-center py-2>
                <span class="opensanssemibold cblack">Shipping Address</span>
              </v-flex>
              <v-flex xs12 py-2>
                <span>
                  {{ order.deliveryAddress.firstName }}&nbsp;
                  {{ order.deliveryAddress.lastName }}
                </span>
                <br />
                <span>
                  {{ order.deliveryAddress.address }}
                </span>
                <br />
                <span>
                  {{ order.deliveryAddress.city }},
                  {{ order.deliveryAddress.state }}
                </span>
                <br />
                <span>
                  {{ order.deliveryAddress.pincode }}
                </span>
              </v-flex>
              <v-flex xs12 align-self-center py-2>
                <span class="opensanssemibold cblack">Contact</span>
              </v-flex>
              <v-flex xs12 py-2>
                <span>
                  <v-icon small>mdi-phone</v-icon>
                  {{ order.deliveryAddress.mobile }}
                </span>
                <br />
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- <v-flex xs12 py-2 py-lg-0>
            <v-layout wrap justify-end>
              <v-flex
                xs6
                sm4
                md4
                lg3
                px-2
                v-if="
                  storage.deliverystatus != 'Cancelled' &&
                  storage.deliverystatus != 'Delivered' &&
                  order.purchasetype == 'Normal'
                "
              >
                <v-btn
                  :ripple="false"
                  depressed
                  dark
                  block
                  tile
                  color="#FF1313"
                  @click="cancelDialog = true"
                >
                  Cancel
                </v-btn>
              </v-flex>
              <v-flex xs6 sm4 md4 lg3 px-2>
                <v-select
                  outlined
                  dense
                  color="#FF1313"
                  placeholder="Order Status"
                  v-model="orderStatus"
                  :items="orderStatuses"
                  item-text="name"
                  item-value="value"
                  item-color="#FF1313"
                  hide-details
                  v-on:input="changeStatus"
                  item-disabled="disabled"
                >
                  <template v-slot:item="{ item }">
                    <span class="text-left">
                      {{ item.name }}
                    </span>
                  </template>
                </v-select>
              </v-flex>
              <v-flex
                xs6
                sm4
                md4
                lg3
                px-2
                v-if="
                  storage.deliverystatus == 'Placed' ||
                  storage.deliverystatus == 'Shipped' ||
                  storage.deliverystatus == 'In Transit' ||
                  storage.deliverystatus == 'Delivered'
                "
              >
                <v-sheet outlined color="#70707029" rounded>
                  <v-card
                    :href="
                      baseURL +
                      '/Purchase/printreceipt?id=' +
                      order._id +
                      '&productid=' +
                      storage.product._id
                    "
                    flat
                    color="#F5F7FC"
                    height="40px"
                  >
                    <v-layout wrap justify-center fill-height>
                      <v-flex xs12 align-self-center>
                        <span
                          style="
                            font-family: opensansbold;
                            font-size: 14px;
                            color: #1fb13b;
                          "
                        >
                          PRINT RECEIPT
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-sheet>
              </v-flex>
            </v-layout>
          </v-flex> -->
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage", "order", "product"],
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      orderStatus: "ordered",
      orderStatuses: [
        { name: "Ordered", value: "ordered", disabled: true },

        { name: "Packed", value: "packed", disabled: false },
        { name: "Shipped", value: "shipped", disabled: false },
        {
          name: "Cancelled By Seller",
          value: "cancelledbyseller",
          disabled: false,
        },
        { name: "Out for Delivery", value: "outfordelivery", disabled: false },
        { name: "Delivered", value: "delivered", disabled: false },
        // { name: "Return", value: "Return", disabled: false },
      ],
      cancelDialog: false,
    };
  },
  computed: {
    CATTYPE() {
      return localStorage.getItem("category");
    },
  },
  watch: {
    orderStatus() {
      if (this.orderStatus == "shipped") {
        this.orderStatuses[1].disabled = true;
      }
      if (this.orderStatus == "cancelledbyseller") {
        this.orderStatuses[0].disabled = true;
        this.orderStatuses[1].disabled = true;
        this.orderStatuses[2].disabled = true;
        this.orderStatuses[3].disabled = true;
        this.orderStatuses[4].disabled = true;
        this.orderStatuses[5].disabled = true;
      }
      if (this.orderStatus == "delivered") {
        this.orderStatuses[0].disabled = true;
        this.orderStatuses[1].disabled = true;
        this.orderStatuses[2].disabled = true;
        this.orderStatuses[3].disabled = true;
        this.orderStatuses[4].disabled = true;
        this.orderStatuses[5].disabled = true;
      }
      if (this.orderStatus == "outfordelivery") {
        this.orderStatuses[0].disabled = true;
        this.orderStatuses[1].disabled = true;
        this.orderStatuses[2].disabled = true;
        this.orderStatuses[3].disabled = false;
        this.orderStatuses[4].disabled = false;
        this.orderStatuses[5].disabled = false;
      }
    },
  },
  beforeMount() {
    if (this.storage.productOrderStatus)
      this.orderStatus = this.product.productOrderStatus;
  },
  methods: {
    cancelProduct() {
      this.$emit("stepper", {
        type: "cancell",
        product: this.storage,
        transactionid: this.order._id,
      });
      this.cancelDialog = false;
    },
    changeStatus() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/seller/ordered/product/status/change",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          orderid: this.order._id,
          productid: this.product._id,
          productOrderStatus: this.orderStatus,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.orders = response.data.data;
            this.storage.deliverystatus = this.orderStatus;

            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
